<template>
  <el-date-picker
    v-model="newValue"
    :type="type"
    :picker-options="type == 'datetimerange' ? pickerOptions : []"
    range-separator="至"
    :start-placeholder="startTime"
    :end-placeholder="endTime"
    :placeholder="placeholder"
    :size='size'
    align="right"
    :value-format="format"
    :format ='format'
    @change="changeTime"
  />
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    },
    size:{
      default:''
    },
    type: {
      default: 'date'
    },
    format: {
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    startTime: {
      default: '开始时间'
    },
    placeholder: {
      default: '选择时间'
    },
    endTime: {
      default: '结束时间'
    },
    date:{
      default:'yyyy-MM-dd HH:mm:ss'
    }
  },
  data() {
    return {
      newValue: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(data) {
        this.newValue = data
      }
    },
    newValue(data) {
      this.$emit('input', data)
    }
  },
  methods: {
    changeTime(data) {
      this.newValue = data
    }
  }
}
</script>

